import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { INewBuilding } from '../../../types/newBuldings';
import { IOffice } from '../../../types/offices';
import { getGeoObject, IGetGeoObjectOptions } from './getGeoObject';

type MapPinData = {
  newBuildings: INewBuilding[];
  offices?: IOffice[];
  defaultPinImage?: string | null;
};

export function getPins({ newBuildings, offices = [], defaultPinImage = null }: MapPinData): IMapGeoObject[] {
  return [...newBuildings, ...offices].reduce((acc, curr) => {
    const options: IGetGeoObjectOptions = {
      name: String(curr.id),
      id: String(curr.id),
      coordinates: curr.coordinates,
      pinImage: defaultPinImage,
    };

    if (isOffice(curr) && curr.pinImage) {
      options.pinImage = curr.pinImage;
    }

    const pin = getGeoObject(options);

    if (!pin) {
      return acc;
    }

    return [...acc, pin];
  }, []);
}

function isOffice(entity: IOffice | INewBuilding): entity is IOffice {
  return 'pinImage' in entity;
}
